import { render, staticRenderFns } from "./SettlementDetails.vue?vue&type=template&id=037e2166&scoped=true&"
import script from "./SettlementDetails.vue?vue&type=script&lang=js&"
export * from "./SettlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./SettlementDetails.vue?vue&type=style&index=0&id=037e2166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e2166",
  null
  
)

export default component.exports